import { JetView } from 'webix-jet';
import {
    devConfig, // Configuration for development environment
    countries, // List of countries
    providersCasino, // List of casino providers
    gamesCasino, // List of casino games
    profile, // User profile information
} from 'config/config';

/**
 * Class representing the filter view for partners' products.
 * @extends JetView
 */
export default class FilterPartnersProductsView extends JetView {
    /**
     * Configures the UI components of the filter view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration

        const left = {
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text', // Input for ID
                            name: 'Id',
                            type: 'number',
                            label: "<span class='icon-drivers-license-o'></span>" + _('Id'),
                            labelPosition: 'top',
                            placeholder: _('Id'),
                            invalidMessage: _('Id is required'), // Validation message
                        },
                        {
                            view: 'richselect', // Dropdown for selecting products
                            name: 'Product',
                            localId: 'product:combo',
                            label: _('Producto'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: {
                                body: {
                                    dataFeed: function (text) {
                                        // Data fetching for product selection
                                        var vthis = this;
                                        if (text.length > 2) {
                                            webix
                                                .ajax()
                                                .headers({
                                                    'Content-type': 'application/json',
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'es/Select/GamesCasinoSelect',
                                                    '{"Filter":"' + text + '"}',
                                                    {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            webix.message('Error! '); // Error message
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            var resp = JSON.parse(text);
                                                            if (!resp.HasError) {
                                                                vthis.parse(resp.Data); // Parse and display data
                                                            }
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            },
                        },
                        {
                            view: 'richselect', // Dropdown for selecting partners
                            name: 'Partner',
                            label: _('Partner'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            value: profile.PartnerSelected, // Default selected partner
                            options: profile.Partners, // List of partners
                        },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'richselect', // Dropdown for activation status
                            name: 'IsActivate',
                            label: "<span class='icon-state'></span>" + _('Estado'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                { id: 'null', value: _('Todos') },
                                { id: 'A', value: _('Activado') },
                                { id: 'I', value: _('Inactivado') },
                            ],
                        },
                        { id: 'grav2', gravity: 2 }, // Gravity for layout
                    ],
                },
            ],
        };

        const left2 = {
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'richselect', // Dropdown for verification status
                            name: 'IsVerified',
                            label: "<span class='icon-verified_user'></span>" + _('Verificado'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                { id: 'null', value: _('Todos') },
                                { id: 'A', value: _('Activado') },
                                { id: 'I', value: _('Inactivado') },
                            ],
                        },
                        {
                            view: 'richselect', // Dropdown for country filter
                            name: 'FilterCountry',
                            label: "<span class='icon-language'></span>" + _('Filtro País'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                { id: 'null', value: _('Todos') },
                                { id: 'A', value: _('Activado') },
                                { id: 'I', value: _('Inactivado') },
                            ],
                        },
                        {
                            view: 'text', // Input for maximum value
                            name: 'Maximum',
                            type: 'number',
                            label: _('Máximo'),
                            labelPosition: 'top',
                            placeholder: _('Máximo'),
                            invalidMessage: _('Máximo is required'), // Validation message
                        },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text', // Input for minimum value
                            name: 'Minimum',
                            type: 'number',
                            label: _('Mínimo'),
                            labelPosition: 'top',
                            placeholder: _('Mínimo'),
                            invalidMessage: _('Mínimo is required'), // Validation message
                        },
                        {
                            view: 'text', // Input for processing time
                            name: 'ProcessingTime',
                            type: 'number',
                            label: "<span class='icon-history'></span>" + _('Tiempo Procesamiento'),
                            labelPosition: 'top',
                            placeholder: _('Tiempo Procesamiento'),
                            invalidMessage: _('Tiempo Procesamiento is required'), // Validation message
                        },
                        { id: 'grav3', gravity: 1 }, // Gravity for layout
                    ],
                },
            ],
        };

        const upper_section = {
            css: 'father-container',
            height: document.body.offsetWidth < 500 ? 250 : 0, // Responsive height
            rows: [
                {
                    margin: 10,
                    cols: [left], // Left section
                },
            ],
        };

        const upper_section2 = {
            css: 'father-container',
            height: document.body.offsetWidth < 500 ? 320 : 0, // Responsive height
            rows: [
                {
                    margin: 10,
                    cols: [left2], // Second left section
                },
            ],
        };

        const accordion_section = {
            id: 'b5',
            rows: [
                {
                    multi: true,
                    view: 'accordion', // Accordion for advanced filters
                    css: 'betShop',
                    collapsed: true,
                    paddingY: 10,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros Avanzados'), // Header for advanced filters
                            body: {
                                padding: 10,
                                rows: [upper_section2], // Content of advanced filters
                            },
                        },
                    ],
                },
            ],
        };

        const buttons = {
            id: 'b2',
            rows: [
                {
                    margin: 10,
                    responsive: 'b2',
                    cols: [
                        { id: 'grav', gravity: 4 }, // Gravity for layout
                        {
                            view: 'button', // Button to add partner provider
                            value: _('Añadir Proveedor Partner'),
                            type: 'form',
                            hidden: !devConfig.getPermAction('partnersProvidersAdd', 'Add'), // Permission check
                            css: 'prm-partnersProvidersAdd',
                            width: screen == 'small' ? 0 : 200,
                            minWidth: 200,
                            click: () => {
                                this.app.callEvent('addProductPartner:button', [[]]); // Event call for adding partner
                            },
                        },
                        {
                            view: 'button', // Button to clear filters
                            value: _('Limpiar'),
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            click: () => {
                                this.getRoot().clear(); // Clear form values
                            },
                        },
                        {
                            view: 'button', // Button to consult/filter products
                            value: _('Consultar'),
                            type: 'form',
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            click: () => {
                                const filterdata = this.getRoot().getValues(); // Get filter values
                                this.app.callEvent('partnerProducts:filter', [filterdata]); // Event call for filtering
                                $$('b1').collapse(); // Collapse filter section
                                $$('a5').scrollTo(100, 0); // Scroll to specific position
                            },
                        },
                    ],
                },
            ],
        };

        const accordion_section1 = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion', // Accordion for main filters
                    css: 'betShop',
                    collapsed: true,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'), // Header for main filters
                            id: 'b1',
                            body: {
                                padding: 10,
                                rows: [
                                    upper_section, // Upper section of filters
                                    accordion_section, // Advanced filters section
                                    buttons, // Buttons section
                                ],
                            },
                        },
                    ],
                },
            ],
        };

        return {
            view: 'form', // Main form view
            type: 'clean',
            rows: [accordion_section1], // Main content
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }

    /**
     * Initializes the view and sets up responsive behavior.
     * @param {Object} grid - The grid component.
     */
    init(grid) {
        webix.ready(function () {
            if (screen.width < 500) {
                $$('grav').hide(); // Hide elements for small screens
                $$('grav2').hide();
                $$('grav3').hide();
            }
        });
    }
}

// FILE DOCUMENTED
